import enUSTranslations from './en-US';
import ptBRTranslations from './pt-BR';

const translations: any = {
  'en-US': enUSTranslations,
  'pt-BR': ptBRTranslations,
};

export default translations;
